import searchIconUrl from '@/assets/icons/search.svg'

import { Headline, HeadlineEmphasis, HeroWrapper, SearchPlaceholder, SearchTrigger } from './styles'

interface HeroSectionProps {
  /** 검색바 클릭 시 — 다음 주소검색 popup 트리거 */
  onSearchClick?: () => void
  /**
   * 검색바 노출 여부.
   * 비회원(토큰 없음)에는 검색 기능 제공 안 함 — page.tsx에서 hasToken()으로 결정 후 전달.
   */
  showSearch?: boolean
}

export default function HeroSection({ onSearchClick, showSearch = true }: HeroSectionProps) {
  return (
    <HeroWrapper>
      <Headline>
        <HeadlineEmphasis>주말, 공휴일</HeadlineEmphasis>에도
        <br />
        매일 이용 가능해요
      </Headline>

      {showSearch && (
        <SearchTrigger
          type='button'
          onClick={onSearchClick}
          aria-label='주소로 서비스 지역 검색'>
          <img
            src={searchIconUrl}
            alt=''
            width={20}
            height={20}
          />
          <SearchPlaceholder>시·구·동 이름으로 검색 (예: 강남구, 고양시)</SearchPlaceholder>
        </SearchTrigger>
      )}
    </HeroWrapper>
  )
}
